module.exports = __webpack_public_path__ + "static/media/demo_3.d1690f9e.mp4";